import React from "react";
import AddEntityPopup from "components/Records/NewRecordPages/AddEntityPopup";
import { campaignAPI } from "api/Campaigns/CampaignAPI";

interface AddCampaignPopupProps {
  open: boolean;
  onClose: () => void;
  onSaved?: (newCampaign: any) => void;
}

const AddCampaignPopup: React.FC<AddCampaignPopupProps> = ({ open, onClose, onSaved }) => {
  return (
    <AddEntityPopup
      open={open}
      onClose={onClose}
      title="Add New Campaign"
      createFunction={campaignAPI.create as (data: Record<string, any>) => Promise<any>}
      fields={[
        { name: "name", label: "Campaign Name", required: true },
        { name: "description", label: "Description", multiline: true, rows: 3 },
      ]}
      onSaved={onSaved}
    />
  );
};

export default AddCampaignPopup;
